import { TrialPeriod } from "@/components";
import { Button, Stack, Typography } from "@mui/material";
import { FC, useState } from "react";
import { ChangeTrialPeriodProps } from "./change-trial-period.types";
import { useUpdateTrialPeriod } from "@/queries";

const ChangeTrialPeriod: FC<ChangeTrialPeriodProps> = ({ userId }) => {
  const { updateTrialPeriod, isSetTrialPeriodLoading } = useUpdateTrialPeriod();

  const [trialSettings, setTrialSettings] = useState<{
    endDate?: string;
    isInfinite?: boolean;
  }>();
  return (
    <Stack width={"100%"}>
      <Typography variant="h6" gutterBottom>
        Trial Period
      </Typography>

      <TrialPeriod
        onChange={(newEndDate, isInfinite) =>
          setTrialSettings({ endDate: newEndDate, isInfinite })
        }
      />

      <Button
        type="button"
        variant="contained"
        color="secondary"
        onClick={() => {
          if (trialSettings) {
            updateTrialPeriod({
              userId,
              freeTrialEndDate: trialSettings.endDate,
              hasInfiniteFreeTrial: trialSettings.isInfinite,
            });
          }
        }}
        disabled={!trialSettings || isSetTrialPeriodLoading}
        loading={isSetTrialPeriodLoading}
        sx={{ mt: 2 }}
      >
        Change
      </Button>
    </Stack>
  );
};

export { ChangeTrialPeriod };
